import { AbstractModel } from '../base';
import {
  ComputationBinaryOperators,
  ComputationNodeSubtype,
  ComputationNodeType
} from './computation.constants';
import {
  IAbstractComputationNode,
  IAbstractComputationNodeData
} from './computation.types';

export abstract class AbstractComputationNode extends AbstractModel
  implements IAbstractComputationNode {
  readonly order: number = 1;
  readonly type: ComputationNodeType;
  readonly subtype: ComputationNodeSubtype | ComputationBinaryOperators;
  readonly constant: number | null;

  protected constructor(data: IAbstractComputationNodeData) {
    super();

    this.validate(data, ['type']);

    this.type = data.type!;

    if (data.order) {
      this.order = data.order;
    }

    this.subtype = data.subtype ?? ComputationBinaryOperators.Add;

    this.constant = data.constant ?? null;
  }

  public isOperand(): boolean {
    return this.type == ComputationNodeType.Operand;
  }

  public isOperator(): boolean {
    return this.type == ComputationNodeType.Operator;
  }

  public isUnaryOperator(): boolean {
    if (!this.isOperator()) {
      return false;
    }
    switch (this.subtype) {
      case ComputationBinaryOperators.Ceil:
      case ComputationBinaryOperators.Floor:
      case ComputationBinaryOperators.Abs:
        return true;
      default:
        return false;
    }
  }

  public isStartBracket(): boolean {
    return Boolean(
      this.type === ComputationNodeType.Operator &&
        this.subtype === ComputationBinaryOperators.Start_bracket
    );
  }

  public isCloseBracket(): boolean {
    return Boolean(
      this.type === ComputationNodeType.Operator &&
        this.subtype === ComputationBinaryOperators.Close_bracket
    );
  }
}
